const mutations = {
  setSalesHierarchyMasterDropDown(state, payload) {
    state.salesHierarchyMasterDropDown = payload;
  },
  setSalesHierarchyMasterList(state, payload) {
    state.salesHierarchyMasterArr = payload;
  },
  setMasterGeoElement(state, payload) {
    state.geoElemets = payload;
  },
  setConfigurationDivisionHold(state, payload) {
    state.configurationDivisionValue = payload
  },
  setSalesHierarchyMasterConfigurationList(state, payload) {
    state.salesHierarchyMasterConfigurationArr = payload;
  },
  setSalesHierarchyMasterUploadList(state, payload) {
    state.salesHierarchyMasterUploadArr = payload;
  },
  setSalesHierarchyDtlElemetDisable(state, payload) {
    state.salesHierarchyDtlElemetDisableGeoRole = payload;
  },
};

export default mutations;
